// extracted by mini-css-extract-plugin
export const inputEmail = "forget-password-module--inputEmail--4uR7t";
export const btn = "forget-password-module--btn--ZPuC2";
export const errorMsg = "forget-password-module--errorMsg--4cSmZ";
export const txtBack = "forget-password-module--txtBack--Gai48";